module.exports = "/src/views/eternal-dev/businesses/gas-station/images/light/XEro/header-background.svg";